import {
  DELIVERY_IN_HOUSE,
  DELIVERY_THIRD_PARTY,
  SELF_MANAGED_DELIVERY_PARTNER, STORAGE_KEY_IS_USING_RULE_BASED_CONFIG
} from "./Constants";
import {getFromStorage} from "../services/LocalStorage";
import {isNotEmptyString} from "./Util";

/**
 * This method will return all available delivery partners according to the
 * deliveryPartnerSelection.
 * with new implementation - should get partners from availableDeliveryPartners
 * and need to add self-managed option as well if there is any available
 * delivery partners.
 * With old implementation - should get partners from available3plPartner
 * Can remove old implementation after stabilizing - CLK-2861
 *
 * @param deliveryPartnerSelection
 */

export function getAvailableDeliveryPartners(deliveryPartnerSelection) {
  if (deliveryPartnerSelection == null) {
    return [];
  }
  if (deliveryPartnerSelection.availableDeliveryPartners != null) {
    const availablePartners = [];
    availablePartners.push(
        ...deliveryPartnerSelection.availableDeliveryPartners.filter(
            partner => partner.id));
    const isRuleBasedNewOrder =
        getFromStorage(STORAGE_KEY_IS_USING_RULE_BASED_CONFIG) &&
        deliveryPartnerSelection.availableDeliveryPartners.filter(
            partner => isLegacyDefaultInHousePartner(partner)).length === 0;

    if (isRuleBasedNewOrder && availablePartners.length > 0) {
      availablePartners.push({
        'id': SELF_MANAGED_DELIVERY_PARTNER,
        'deliveryMode': DELIVERY_IN_HOUSE
      });
    }
    return availablePartners;
  }
  if (deliveryPartnerSelection.availableThirdPartyDeliveryPartners == null) {
    return [];
  }
  return deliveryPartnerSelection.availableThirdPartyDeliveryPartners.map(
      dp => {
        return {'id': dp.id, 'deliveryMode': DELIVERY_THIRD_PARTY}
      });
}

function isLegacyDefaultInHousePartner(partner) {
  return partner != null && partner.id === "" && partner.deliveryMode
      === DELIVERY_IN_HOUSE
}

/**
 * Check whether are there any available delivery partners or available delivery
 * partner in both new and legacy
 */
export function isNoDeliveryPartner(order) {
  const deliveryPartners = getAvailableDeliveryPartners(
      order.deliveryPartnerSelection);

  return deliveryPartners.length === 0 && !isNotEmptyString(
          order?.deliveryPartnerSelection?.selectedDeliveryPartner)
      && !isNotEmptyString(order?.deliveryDetails?.deliveryPartnerId);
}

export function isUsingRUleBased() {
  return getFromStorage(STORAGE_KEY_IS_USING_RULE_BASED_CONFIG);
}

/**
 * This is a temporary method to handel transition period orders.
 * If order selected delivery partner is null and contains available 3pl delivery partners
 * then get value from deliveryDetails.
 * todo can remove this after the transition
 */
export function isOnGoingTransitionPeriodOrder(order) {
  if (order.deliveryPartnerSelection?.selectedDeliveryPartner != null) {
    return false;
  }
  if (order.deliveryPartnerSelection?.availableThirdPartyDeliveryPartners
      != null
      && order.deliveryPartnerSelection?.availableThirdPartyDeliveryPartners.length
      > 0) {
    return order?.deliveryDetails?.deliveryPartnerId != null;
  }
  return false;
}

export function getSelectedDeliveryPartnerId(order, available3plPartners) {
  if (order.tempSelected3pl) {
    return order.tempSelected3pl.id;
  } else if (available3plPartners.size > 0) {
    if(order.deliveryPartnerSelection?.selectedDeliveryPartner?.id != null) {
      return order.deliveryPartnerSelection?.selectedDeliveryPartner?.id;
    } else if (isOnGoingTransitionPeriodOrder(order)
        && order.deliveryDetails?.deliveryPartnerId) {
      return order.deliveryDetails?.deliveryPartnerId;
    } else {
      return SELF_MANAGED_DELIVERY_PARTNER;
    }
  }
  return null;
}